import axios from "axios";
import Swal from "sweetalert2";

export const deleteAnimal = async (id, updateListCallback) => {
    const result = await Swal.fire({
        title: "Silmek istediğinizden emin misiniz?",
        text: "Bu işlem geri alınamaz!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Evet, sil!",
        cancelButtonText: "Hayır, iptal et"
    });

    if (result.isConfirmed) {
        try {
            await axios.delete(`animal/${id}/`);
            Swal.fire("Başarılı!", "Kayıt silindi.", "success");

            if (updateListCallback) updateListCallback(id);
        } catch (err) {
            Swal.fire("Hata!", "Silme işlemi başarısız.", "error");
            console.error(err);
        }
    }
};